import React, { useEffect } from 'react';
import { Toast } from 'react-bootstrap';

export default function Notificacion(props) {

    // Ocultar el Toast automáticamente después de 3 segundos
    useEffect(() => {
        if (props.show) {
            const timer = setTimeout(() => {
                props.setShow();
            }, 3000);

            // Limpiar el temporizador si el componente se desmonta o si show cambia
            return () => clearTimeout(timer);
        }
    }, [props.show]);

    const handleHideToast = () => {
        props.setShow();
    };

    return (
        <div>
            <Toast
                show={props.show}
                /* onClose={handleHideToast}  */
                style={{ position: 'absolute', top: 20, right: 20 }}>
                <Toast.Header>
                    <strong className="me-auto">Notificación</strong>
                </Toast.Header>
                <Toast.Body>
                    Contribuyente Cesar Ratia acaba de declarar 
                </Toast.Body>
            </Toast>
        </div>
    );
}
